type LoadingTextProps = {
  children?: string;
  className?: string;
};

export default function LoadingText({ children = "Loading…", className = "" }: LoadingTextProps) {
  return <p className={`text-sm text-gray-400 ${className}`}>{children}</p>;
}
